<script setup lang="ts">
import VideoCallGlobalHost from "~/components/video-call/VideoCallGlobalHost.client.vue";
import { useAuthStore } from "~/stores/auth";
import {
  useStudentAccess,
  useStudentAccessRevalidation,
} from "~/composables/useStudentAccess";
import { studentLearningAccessRedirect } from "~/utils/studentAccess";
import {
  PLATFORM_APP_TITLE,
  SCHOOL_LOGIN_PENDING_TITLE,
} from "~/utils/loginHost";
import { useSchoolDomainBrand } from "~/composables/useSchoolDomainBrand";
import {
  schoolBrowserFavicon,
  schoolBrowserTitle,
} from "~/utils/schoolBrowserBrand";

const auth = useAuthStore();
const route = useRoute();
const domainBrand = useSchoolDomainBrand();
const schoolName = computed(() => domainBrand.preferences.value?.school_name);
useHead(() => ({
  title: domainBrand.platformHost
    ? PLATFORM_APP_TITLE
    : schoolName.value || SCHOOL_LOGIN_PENDING_TITLE,
  titleTemplate: domainBrand.platformHost
    ? null
    : (title) => schoolBrowserTitle(title, schoolName.value),
  link: [
    {
      key: "app-favicon",
      id: "app-favicon",
      rel: "icon",
      href: domainBrand.platformHost
        ? "/favicon.ico"
        : schoolBrowserFavicon(domainBrand.preferences.value),
    },
  ],
}));
onMounted(async () => {
  if (!domainBrand.platformHost) await domainBrand.resolve();
});
const { canAccessLearning } = useStudentAccess();
useStudentAccessRevalidation();

watch(
  () => [
    auth.profileLoaded,
    auth.user.permissions.isStudent,
    canAccessLearning.value,
    route.path,
  ],
  () => {
    if (!auth.profileLoaded || !auth.user.permissions.isStudent) return;
    const redirect = studentLearningAccessRedirect(route.path, {
      ...auth.user.studentAccess,
      hasSchool: Boolean(auth.user.studentAccess.schoolContact),
    });
    if (redirect) navigateTo(redirect, { replace: true });
  },
);
</script>

<template>
  <div class="teachplus-app-root">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <ClientOnly>
      <VideoCallGlobalHost />
    </ClientOnly>
  </div>
</template>

<style>
.teachplus-app-root {
  display: contents;
}
</style>
